import { NgModule } from '@angular/core';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { FileuploaderFilepondComponent } from './fileuploader-filepond.component';
import { FileuploaderFilepondService } from './fileuploader.filepond.service';

// Register the plugin
registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);


@NgModule({
  declarations: [
    FileuploaderFilepondComponent
  ],
  providers: [
   FileuploaderFilepondService
],
  imports: [
    FilePondModule,
  ],
  exports: [
    FileuploaderFilepondComponent
    ]
})
export class FileUploaderModule { }
